import {
  logAccountCreated as amplitudeLogAccountCreated,
  setUser
} from "lib/shared/events";

export function genFormKey() {
  return (Math.random() + 1).toString(36).substring(7);
}

// When a user is created via ajax call, we want to set the user
// properties on window.amplitudeUser without
// relying on a page refresh and then log the event accordingly.
export function logAccountCreated(properties) {
  if (!properties.userID) {
    console.warn("No user identifier for amplitude events");
    return;
  }
  window.amplitudeUser = { id: properties.userID, properties };

  setUser();
  amplitudeLogAccountCreated();
}

export function buildSignupParams(values, subscriptionType = null) {
  return {
    body: JSON.stringify({
      subscription: subscriptionType,
      user: { ...values, simplified_signup: true }
    }),
    method: "POST"
  };
}

// This method is a workaround for the plan page -> sell page transition
// When a user successfully creates an account prior to the sell form.
// Because it's not a full page re-render, we need to replace the header with the
// Appropriate copy + link
export function replaceHeaderCopy() {
  const container = document.querySelector(".sign-in-link");
  if (!container) return;

  container.querySelector(".helplink").classList.toggle("!tw-hidden");
  container.querySelector(".member-link").classList.toggle("!tw-hidden");
}

// LE-1388 (Product Request): This is when a user chooses to cancel their payment like when they use Apple Pay
// or Google Pay and close the payment modal.  We have decided this is not an "error"
// so we are swallowing up the error message.
export function setNonWalletErrors(error, setStripeErrorMessage) {
  if (
    error?.code === "incomplete" &&
    error?.message === "Please fill in your card details." &&
    error?.type === "validation_error"
  ) {
    return;
  }
  // Handle other errors
  setStripeErrorMessage(error.message);
}
